import { createSlice } from '@reduxjs/toolkit';
import { Acquisitions } from '../../@types/Acquisitions.type';

// `products` (the legacy /sales/products catalog) was removed — product display
// is now sourced from the heru-sales-transaction-engine catalog. Only `acquisitions`
// (entitlement / "what the user owns") remains here.
interface ProductsState {
	acquisitions: Acquisitions[];
}

const initialState: ProductsState = {
	acquisitions: [],
};

export const productsSlice = createSlice({
	name: 'productList',
	initialState,
	reducers: {
		addAcquisitions: (state, action) => {
			state.acquisitions = action.payload;
		},
	},
});

export const { addAcquisitions } = productsSlice.actions;

export default productsSlice.reducer;
